import USAMap from "react-usa-map";
import Pin from "./pin";
const UsaMap = () => {
  const scroll = (target) => {
    document.querySelector("#" + target).scrollIntoView({
      behavior: "smooth",
    });
  };
  const statesCustomConfig = () => {
    return {
      IN: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      KY: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      MO: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      OH: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      PA: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      TN: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      IL: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      MI: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      WI: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      NC: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      VA: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      TX: {
        fill: "#006225",
        // clickHandler: (event) => scroll(event.target.dataset.name),
      },
      OK: {
        fill: "#006225",
        // clickHandler: (event) => scroll(event.target.dataset.name),
      },
      KS: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      MS: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      AL: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      IA: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      GA: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      SC: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      MD: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      DC: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      AR: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      FL: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      WV: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      NY: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      NJ: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      ME: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      VT: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      NH: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      CT: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      MA: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
      RI: {
        fill: "#006225",
        clickHandler: (event) => scroll(event.target.dataset.name),
      },
    };
  };
  return (
    <div className="relative hidden w-full h-auto map-wrapper lg:block">
      <div className="mapContainer">
        <Pin top="41" left="54" bgcolor={`white`} />
        <Pin top="39.5" left="58" bgcolor={`white`} />
        <Pin top="40.2" left="55.5" bgcolor={`white`} />
        <Pin top="43.5" left="60.3" bgcolor={`white`} />
        <Pin top="45.5" left="55" bgcolor={`white`} />

        <Pin top="32" left="61" bgcolor={``} />
        {/* I needed to remove the above by unsetting the color, removing the pin will remove a different one */}
        <Pin top="27" left="65" bgcolor={`white`} />

        <Pin top="26" left="61" bgcolor={`white`} />

        <Pin top="19.8" left="67" bgcolor={`white`} />
        <Pin top="25" left="71" bgcolor={`white`} />

        <Pin top="30.7" left="67.2" bgcolor={`white`} />
        <Pin top="32.1" left="67.9" bgcolor={`white`} />
        <Pin top="35.7" left="66" bgcolor={`white`} />
        <Pin top="36.1" left="67.4" bgcolor={`white`} />

        <Pin top="42" left="68.7" bgcolor={`white`} />
        <Pin top="39.8" left="70.2" bgcolor={`white`} />

        <Pin top="48.8" left="67.5" bgcolor={`white`} />

        <Pin top="38.5" left="83.3" bgcolor={`white`} />

        <Pin top="36.3" left="71" bgcolor={`white`} />
        <Pin top="34.5" left="72.6" bgcolor={`white`} />
        <Pin top="32.5" left="72.9" bgcolor={`white`} />
        <Pin top="29" left="74.3" bgcolor={`white`} />
        <Pin top="31.3" left="75.3" bgcolor={`white`} />

        <Pin top="26.2" left="78.5" bgcolor={`white`} />

        <Pin top="46.5" left="78.5" bgcolor={`white`} />


        <Pin top="21.4" left="85.7" bgcolor={`white`} />

        <Pin top="21.7" left="88.5" bgcolor={`white`} />
        <Pin top="21.5" left="90" bgcolor={`white`} />
        <Pin top="20.7" left="91" bgcolor={`white`} />

        <Pin top="22.4" left="91.1" bgcolor={`white`} />

        <Pin top="22.5" left="89" bgcolor={`white`} />
        <Pin top="24.9" left="88.5" bgcolor={`white`} />

        <Pin top="49" left="83" bgcolor={`white`} />


        <USAMap customize={statesCustomConfig()} />
      </div>
      <div className="flex flex-wrap justify-center w-full gap-5 mt-10 text-sm ">
        <div>
          <div className="inline-block align-middle">
            <div className="flex items-center justify-center w-4 h-4 bg-green-900">
              <div className="w-1.5 h-1.5 rounded inline-block full bg-white" />
            </div>
          </div>
          <span className="inline-block ml-1 font-medium">ATS Location</span>
        </div>
        <div>
          <div className="inline-block ml-4 align-middle">
            <div className="flex items-center justify-center w-4 h-4 bg-green-900"></div>
          </div>
          <span className="inline-block ml-1 font-medium">Served by ATS</span>
        </div>
      </div>
    </div>
  );
};

export default UsaMap;
